/**
 * JOStory — "En 1993..." history block with stats
 */
import React from "react";
import { useSettings } from "@/lib/useSettings";

export default function JOStory() {
  const { settings: s } = useSettings();
  const founded = s?.founded_year || 1993;
  const years = new Date().getFullYear() - founded;
  const story = s?.story_text || "Un lieu où il est agréable de venir découvrir un grand choix de végétaux dans un cadre propice à la flânerie, où le chant des oiseaux se mêle au bruit de l'eau.";
  const title = s?.story_title || "En 1993, un passionné créa une jardinerie comme on en retrouve peu";
  const subtitle = s?.story_subtitle || "Un havre de paix à Istres au cœur des Bouches-du-Rhône";
  const heroImg = s?.universe_jardinerie?.hero_image || s?.hero_image;

  return (
    <section className="jo-section jo-section--alt" data-testid="jo-story">
      <div className="jo-container">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Left — image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="jo-image-frame aspect-[4/5]">
              {heroImg && <img src={heroImg} alt="Jardins d'Éole — jardinerie" loading="lazy" />}
            </div>
          </div>

          {/* Right — text + stats */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="jo-section-eyebrow">— Notre histoire</div>
            <h2 className="jo-section-title mb-4">{title}</h2>
            <p className="text-xl text-[var(--jdo-muted)] mb-6 italic" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              {subtitle}
            </p>
            <p className="text-base text-[var(--jdo-muted)] leading-relaxed mb-10 max-w-xl">
              {story}
            </p>

            <div className="grid grid-cols-2 gap-x-10 max-w-md">
              <div className="jo-story-stat">
                <div className="num">{years}</div>
                <div className="label">ans d'expertise</div>
              </div>
              <div className="jo-story-stat">
                <div className="num">{(s?.surface_m2 || 3000).toLocaleString('fr-FR')}</div>
                <div className="label">m² de jardinerie</div>
              </div>
              <div className="jo-story-stat">
                <div className="num">{s?.team_size?.match(/\d+/)?.[0] || "8"}</div>
                <div className="label">passionnés à votre service</div>
              </div>
              <div className="jo-story-stat">
                <div className="num">{(s?.intervention_zones_list || []).length || 7}</div>
                <div className="label">communes desservies</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
